import { gql } from "@apollo/client";

export const InstalledBaseNodePathValidation = gql`
    query InstalledBaseNodePathValidation($id: ID!) {
        installedBaseNode(id: $id) {
            id
            pathNodes {
                id
            }
        }
    }
`;
